import { TAqlAuditRowWithSamples } from '@monorepo/types';
import { ModifiersZTableModel } from '../../../table.modifier';
import { ExternalInputPadUtil } from '../../utils/external-input-pad-util';
import { TTextCell } from '../../../table.type';

const rowItmes = ['index', 'size', 'row_qty', 'row_sample', 'row_pass', 'row_fail'];
const rowDisplayMap = {
  index: '',
  size: 'SIZE',
  row_qty: 'QTY',
  row_sample: 'SAMPLE',
  row_pass: 'PASSED',
  row_fail: 'FAILED',
};

const getHeaderDisplayName = (key: string, totalfailed: number, totalfailedRequired: number) => {
  switch (key) {
    case 'size':
      return rowDisplayMap.size;

    case 'row_qty':
      return rowDisplayMap.row_qty;

    case 'row_sample':
      return rowDisplayMap.row_sample;

    case 'row_pass':
      return rowDisplayMap.row_pass;

    case 'row_fail':
      return rowDisplayMap.row_fail + `(${totalfailed}/${totalfailedRequired})`;
    case 'index':
      return rowDisplayMap.index;

    default:
      return '';
  }
};

const getValue = (key: string, rowItem: TAqlAuditRowWithSamples) => {
  switch (key) {
    case 'size':
      return rowItem.size;

    case 'row_qty':
      return rowItem.row_qty;

    case 'row_sample':
      return rowItem.row_sample;

    case 'row_pass':
      return rowItem.row_pass;

    case 'row_fail':
      return rowItem.row_fail;
    case 'index':
      return rowItem.index + 1;

    default:
      return '';
  }
};

export const AUDIT_RESULT_TABLE_MODEL = {
  createModel: (rowInfo: TAqlAuditRowWithSamples[], totalfailed: number, totalfailedRequired: number) => {
    return ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        headerConfig: rowItmes.map((key) => {
          return {
            type: 'TEXT_CELL',
            text: getHeaderDisplayName(key, totalfailed, totalfailedRequired),
          };
        }),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: rowItmes.map((key) => {
            return {
              type: 'TEXT_CELL',
              text: getValue(key, item),
            };
          }),
        };
      },
    );
  },
};

export const AUDITING_TABLE_MODEL = {
  createModel: (rowInfo: TAqlAuditRowWithSamples[], totalfailed: number, totalfailedRequired: number) => {
    return ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        headerConfig: rowItmes.map((key) => {
          return {
            type: 'TEXT_CELL',
            text: getHeaderDisplayName(key, totalfailed, totalfailedRequired),
          };
        }),
        select: {
          position: 'END',
          isMulti: false,
          size: 'LARGE',
        },
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: rowItmes.map((key) => {
            const cell: any = {
              type: 'TEXT_CELL',
              text: getValue(key, item),
            };
            return cell;
          }),
        };
      },
    );
  },
};
